import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Contact() {

    const [messageType, setMessageType] = useState('');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [responseMessage, setResponseMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
// http://127.0.0.1:2245/admin/
// https://cp-api-demo.al-jariyah.com/admin/insertSupport
// https://cp-api.al-jariyah.com/admin/insertSupport
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://cp-api.al-jariyah.com/admin/insertSupport', { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (result.status === 200) {
                setResponseMessage('Mesej berjaya dihantar. Terima kasih!');
                setMessageType('success');
                setFormData({ name: '', email: '', message: '' });
            } else {
                setResponseMessage(result.message || 'Terdapat masalah untuk menghantar mesej. Sila cuba lagi.');
                setMessageType('error');
            }
        } catch (error) {
            console.error('Error sending message:', error);
            setResponseMessage('Ralat pelayan. Sila cuba lagi nanti.');
            setMessageType('error');
        }
    };

    return (
        <div>
            <section className="tf-page-title style-2">    
                <div className="tf-container">
                    <div className="row">
                        <div className="col-md-12">
                            <ul className="breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>Hubungi Kami</li>
                            </ul>
                        </div>
                    </div>
                </div>                    
            </section>
                    
            <section className="tf-contact">
                <div className="tf-container px-3">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="tf-heading style-3">
                                <h4 className="heading">Kami mengalukan pendapat & komen daripada anda.</h4>
                                <p className="sub-heading" style={{paddingLeft:"0px"}}>
                                    Sila tinggalkan mesej sekiranya anda mempunyai sebarang pertanyaan. Kami sedia membantu untuk memberikan penjelasan lanjut mengenai perkhidmatan kami.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <form onSubmit={handleSubmit} className="comment-form">
                                <fieldset className="name">
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder="Nama penuh anda"
                                        className="tb-my-input w-100"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </fieldset>
                                <fieldset className="email">
                                    <input
                                        type="email"
                                        id="email"
                                        placeholder="E-mel anda"
                                        className="tb-my-input w-100"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </fieldset>
                                <fieldset className="message">
                                    <textarea
                                        id="message"
                                        name="message"
                                        rows="4"
                                        placeholder="Mesej anda"
                                        className="w-100"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </fieldset>
                                <div className="btn-submit">
                                    <button className="tf-button" type="submit">Hantar</button>
                                </div>
                                {responseMessage && (
                                    <p style={{ 
                                        marginTop: '10px', 
                                        color: messageType === 'success' ? 'green' : 'red' 
                                    }}>
                                        {responseMessage}
                                    </p>
                                )}
                                {/* {responseMessage && <p style={{ marginTop: '10px', color: 'red' }}>{responseMessage}</p>} */}
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
